var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 28,
    viewBox: "0 0 105 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 28,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_121_3610",
    transform: "matrix(0.008 0 0 0.03 0 -0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_121_3610",
    width: 125,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAiCAYAAAByWNYHAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4gcKDw86AA2uHQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAMaSURBVHja7ZzLaxRBEMZ/q2uicWNWxUdAISwGQyKKESXGF1EPirooBPEgGsSbgjf/Bi/iQRAkQaNeRA+ixgfqIQE1F8WTisEXEUxABNfgmkTceJgOBMlMzezOc6c/GBa6qnv6m2+mpqqn2QTb29GIF2boSwDAhMXxQ4uuoUXX0KJraNE1tOgaWnSNYJBUvxkLnwLw2eSGqXNhDiPqGPWIYw0wF5jt43WtAKrVuf9HHhguctx5isucEub2cVL0DxZOOSA9TXu10M8JCsAg0AtcBx6pGtlp1GoDskALUA/M91HoLcARYJt6iGaa+N0D9gpjJYCtwIEpXBa4NM9EMkSvmTqgQx3PgaPAe5v9NwEXgNUBzH0pcBnY5dJ4rcB5oDlu7/RW4BmwwoZvB9AXkOCLgH4XBT+sol2z109YWLEYuKZCnRnagC6LUOo1LrqU10ze6N3ArLhn7y3AZgv7mQAFzwD7XRzvrF9colCymYXOJmBDwPNKuDRWo7rBfS3ZvEBevW+nQxpIATuAPcI4a0zad9uYw0ugB/gK/ALGTfxuFMFvlQ2fPpWt5zC+1k0AQyaZv4RXwB3FJQ+Mmfh1A1VBif4HuCn4nAM6geMWPkuKvOj3Vfn21yN+tYK9R53fTunZINh7gZ02uXRGIbxfEewLTdqXC/0ueSg4Nurmqw7WGjKCvctNLmEQ/YtgN0tupIWXgYDzoSEHY/nKJQyi5wW72ZJjpdAv5/G8awT7iIOxfOUSBtHHBXuFSXsq5FVHwYGvtJY+Wm6il5IoasRM9HwZ6SA9yVVadAO/S8yuw4QxwZ7Wohv4LtgbI8Tlm2Bv0qIb+CTYT7odFgPkcsLNxDUZYdFfC/aNwDuMDRnDwM8Qc3kj2NeqWv2BDS6V5Sz6Exs+y4BjEeDy2IZPrVtcohzeB4CnZZK9D2LsFtIlmw2cRl7ciQpO+cUl6qL3A4dslG9RwAvgIMYnYC26gFvAOuAhznfQhg23MfbH3cXZMm5ssvepeIuxqaIe2AesB1Zi7FRNYWzXjlKuksX43JpVXBpUIucKl4T+U4L44R/S2YSMqkLNlwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo1);
export default __webpack_public_path__ + "static/media/brand-logo1.8a25e226110094f95d5cfcfe71b5b185.svg";
export { ForwardRef as ReactComponent };